import { IconChevronRight } from '@bbr/icons/chevron-right-outline';
import { TextLink } from './link.tsx';
import type { ComponentProps, ParentProps } from 'solid-js';

export function Breadcrumbs(props: ParentProps) {
	return (
		<ul class="flex flex-wrap items-center gap-2 text-base font-medium text-zinc-500 dark:text-zinc-400">
			{props.children}
		</ul>
	);
}

Breadcrumbs.Separator = () => (
	<li aria-hidden class="flex items-center text-zinc-400 dark:text-zinc-500">
		<IconChevronRight />
	</li>
);

Breadcrumbs.Item = (props: ComponentProps<typeof TextLink>) => (
	<li class="flex shrink items-center">
		<TextLink {...props} color="current" class="flex items-center" />
	</li>
);

Breadcrumbs.Root = (props: ParentProps) => (
	<div class="flex grow flex-col items-start justify-center gap-1" {...props} />
);
